type GetSizeProps = {
  width?: string;
  depth?: string;
  height?: string;
};
export const getSizeNameProduct = ({ width, depth, height }: GetSizeProps): string => {
  const str = [width && 'Ш', depth && 'Г', height && 'В'].filter(Boolean).join('х');
  return str ? `${str}: ` : '';
};

export const getSizeProduct = ({ width, depth, height }: GetSizeProps): string => {
  const str = [width, depth, height].filter(Boolean).join('х');
  return str ? `${str} СМ` : '';
};
